import { Vue } from 'vue-property-decorator';

export async function isFeatureEnabled(featureName: string): Promise<boolean | undefined> {
  try {
    const growthBook = await Vue.prototype.initGrowthBook();
    return growthBook.isOn(featureName);
  } catch (err) {
    // console.log('err: ', err);
    return undefined;
  }
}

export async function getFeatureValue(featureName: string): Promise<string | undefined> {
  try {
    const growthBook = await Vue.prototype.initGrowthBook();
    return growthBook.getFeatureValue(featureName, '');
  } catch (err) {
    // console.log('err: ', err);
    return undefined;
  }
}

export async function getBooleanFeatureValue(featureName: string):
Promise<string | boolean | undefined> {
  try {
    const growthBook = await Vue.prototype.initGrowthBook();
    return growthBook.getFeatureValue(featureName);
  } catch (err) {
    // console.log('err: ', err);
    return undefined;
  }
}
